var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-area__heading"},[_c('top-nav',[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h2',[_vm._v("Estatísticas")])])]),_c('estatisticas-atendente')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }